import { Dispatch } from 'redux'
import getPmsIntegration from '../../axios/pms/pmsIntegrations/get'
import createPmsIntegration from '../../axios/pms/pmsIntegrations/post'
import updatePmsIntegration from '../../axios/pms/pmsIntegrations/put'
import { PmsIntegrationErrorCode, PmsIntegrationPayload, PmsIntegrationUpdatePayload } from '../../axios/pms/pmsIntegrations/types'
import { setPmsIntegration, setPmsIntegrationErrorCode, setPmsIntegrationIsSaving } from '../../action/pmsIntegration'
import { logger } from '../../../logger/logger'

const NOT_PERMITTED_STATUS = 403

type ApiErrorResponse = { response?: { status?: number; data?: { apierror?: { errorStatusCode?: PmsIntegrationErrorCode } } } }

const readStatus = (error: unknown): number | undefined => (error as ApiErrorResponse)?.response?.status

const readErrorCode = (error: unknown): PmsIntegrationErrorCode =>
	(error as ApiErrorResponse)?.response?.data?.apierror?.errorStatusCode ?? 'pms_unavailable'

export const getPmsIntegrationThunk = () => async (dispatch: Dispatch): Promise<void> => {
	try {
		const { data } = await getPmsIntegration()
		dispatch(setPmsIntegration(data?.[0] ?? null))
	} catch (error) {
		dispatch(setPmsIntegration(null))
		if (readStatus(error) !== NOT_PERMITTED_STATUS) {
			logger.error(`Room charge settings could not load the pms integration: ${(error as Error)?.message}`)
		}
	}
}

export const createPmsIntegrationThunk = (payload: PmsIntegrationPayload) => async (dispatch: Dispatch): Promise<boolean> => {
	dispatch(setPmsIntegrationIsSaving(true))
	dispatch(setPmsIntegrationErrorCode(null))
	try {
		const { data } = await createPmsIntegration(payload)
		dispatch(setPmsIntegration(data))
		return true
	} catch (error) {
		dispatch(setPmsIntegrationErrorCode(readErrorCode(error)))
		return false
	} finally {
		dispatch(setPmsIntegrationIsSaving(false))
	}
}

export const updatePmsIntegrationThunk = (id: string, payload: PmsIntegrationUpdatePayload) => async (dispatch: Dispatch): Promise<boolean> => {
	dispatch(setPmsIntegrationIsSaving(true))
	dispatch(setPmsIntegrationErrorCode(null))
	try {
		const { data } = await updatePmsIntegration(id, payload)
		dispatch(setPmsIntegration(data))
		return true
	} catch (error) {
		dispatch(setPmsIntegrationErrorCode(readErrorCode(error)))
		return false
	} finally {
		dispatch(setPmsIntegrationIsSaving(false))
	}
}
